export const PORTE_OPTIONS = [
    { value: "Até 100 contratos", label: "Até 100 contratos" },
    { value: "101 a 300 contratos", label: "101 a 300 contratos" },
    { value: "301 a 500 contratos", label: "301 a 500 contratos" },
    { value: "501 a 1.000 contratos", label: "501 a 1.000 contratos" },
    { value: "Mais de 1.000 contratos", label: "Mais de 1.000 contratos" },
] as const;

export const SYMPTOMS = [
    {
        number: "01",
        question: "“Quem ficou responsável?”",
        body: "Responsabilidades pouco claras fazem tarefas simplesmente pararem entre uma etapa e outra.",
    },
    {
        number: "02",
        question: "“Onde está essa conversa?”",
        body: "Histórico espalhado torna cada retomada mais lenta e dependente de quem estava no atendimento.",
    },
    {
        number: "03",
        question: "“Já fizeram o retorno?”",
        body: "Sem uma próxima ação clara, oportunidades importantes continuam dependendo da memória.",
    },
    {
        number: "04",
        question: "“Por que esse lead não avançou?”",
        body: "Sem rastreabilidade, o gestor enxerga o resultado, mas não consegue enxergar o caminho.",
    },
] as const;

export const COSTS = [
    { title: "Retrabalho", body: "Informações precisam ser copiadas, conferidas ou cadastradas novamente." },
    { title: "Atrasos", body: "O próximo passo depende de alguém lembrar de fazer a demanda continuar." },
    { title: "Perda de contexto", body: "Conversas e decisões ficam espalhadas entre canais e pessoas." },
    { title: "Gestão reativa", body: "O gestor precisa perguntar o que aconteceu antes de conseguir decidir o que fazer." },
] as const;

export const BEFORE_ITEMS = ["WhatsApp", "CRM", "Agenda", "Planilha", "Pessoas", "Setores"] as const;

export const AFTER_ITEMS = [
    { label: "Atendimento", mark: "→" },
    { label: "Contexto", mark: "→" },
    { label: "Tarefa", mark: "→" },
    { label: "Responsável", mark: "→" },
    { label: "Próxima etapa", mark: "→" },
    { label: "Gestão", mark: "✓" },
] as const;

export const WHY_STATS = [
    { value: "+20 anos", body: "desenvolvendo tecnologia para imobiliárias." },
    { value: "+500", body: "imobiliárias atendidas com experiência real em operação e gestão." },
    { value: "Demanda real", body: "o Moov foi pensado a partir da rotina do mercado." },
    { value: "Especialistas", body: "não é um CRM genérico. É uma solução feita para a imobiliária." },
] as const;

export const WHY_STATS_VIDEO = [
    { value: "+20 anos", body: "desenvolvendo tecnologia para imobiliárias." },
    { value: "+500", body: "imobiliárias atendidas." },
    { value: "Demanda real", body: "produto pensado a partir da rotina do mercado." },
    { value: "Especialistas", body: "não é um CRM genérico adaptado." },
] as const;

export const APP_BULLETS = [
    "Consulte informações importantes em poucos toques.",
    "Receba notificações de atividades e movimentações.",
    "Leve a rotina do CRM para o campo.",
] as const;

export const FIT_TEXTO = [
    "Sua equipe já depende de muitas pessoas e etapas para fazer uma demanda avançar.",
    "O WhatsApp é uma parte central do atendimento.",
    "Vocês usam CRM, mas ainda mantêm controles paralelos.",
    "Leads passam por mais de uma pessoa ou setor.",
    "Gestores precisam cobrar atualizações para saber o que está acontecendo.",
    "Existem diferentes funis comerciais e operacionais.",
] as const;

export const FIT_VIDEO = [
    "WhatsApp é parte central do atendimento.",
    "Leads passam por diferentes pessoas ou setores.",
    "Existem diferentes funis e processos.",
    "Tarefas precisam de responsáveis e prazos.",
    "Gestores precisam de mais visibilidade sobre a operação.",
    "A equipe ainda depende de controles paralelos.",
] as const;

export const FAQ_VIDEO = [
    {
        question: "O Moov substitui meu CRM atual?",
        answer: "O Moov pode assumir a gestão de atendimento, relacionamento, tarefas, funis e processos. A aderência e a migração dependem da estrutura atual da imobiliária.",
    },
    {
        question: "Preciso utilizar o SIMOB?",
        answer: "Não necessariamente. A integração com o SIMOB é um dos diferenciais do ecossistema Flexpro, mas o cenário ideal é avaliado junto ao comercial.",
    },
    {
        question: "O WhatsApp fica integrado ao CRM?",
        answer: "Sim. O atendimento pode ficar conectado ao histórico do lead para reduzir perda de contexto e retrabalho.",
    },
    {
        question: "É possível criar diferentes funis?",
        answer: "Sim. O Moov permite estruturar diferentes funis e etapas conforme a realidade da operação.",
    },
    {
        question: "O Moov possui aplicativo?",
        answer: "Sim. O aplicativo permite acompanhar interesses, atividades, imóveis, pessoas e notificações.",
    },
    {
        question: "É possível criar automações?",
        answer: "Sim. É possível estruturar automações para apoiar a continuidade entre etapas, atividades e responsáveis.",
    },
    {
        question: "Como funciona a implantação?",
        answer: "Nosso time acompanha a configuração inicial da operação para apoiar a entrada da equipe no novo ambiente.",
    },
    {
        question: "Como funciona a demonstração?",
        answer: "A demonstração é personalizada para mostrar os fluxos e recursos mais relevantes para a realidade da sua imobiliária.",
    },
] as const;

export const APP_PHONES = [
    { src: "/images/simob/moov-app-left.jpg", alt: "Tela de interesses no aplicativo do Moov", position: "left" },
    { src: "/images/simob/moov-app-main.jpg", alt: "Tela principal do aplicativo do Moov", position: "main" },
    { src: "/images/simob/moov-app-right.jpg", alt: "Tela de atividades no aplicativo do Moov", position: "right" },
] as const;
export const YOUTUBE_EMBED = "https://www.youtube.com/embed/1vjRvXqZ7QM";

export const MOOV_WHATSAPP_URL =
    "https://wa.me/551142805787?text=" +
    encodeURIComponent("Olá! Vi o vídeo do Moov e quero agendar uma demonstração.");

export type PlatformIconName =
    | "zap"
    | "target"
    | "layoutGrid"
    | "clock"
    | "sparkles"
    | "share2"
    | "home"
    | "user"
    | "flag"
    | "key"
    | "penTool"
    | "waves"
    | "building2"
    | "fileText"
    | "globe"
    | "layoutDashboard"
    | "messageCircle"
    | "checkSquare"
    | "smartphone"
    | "tag"
    | "barChart"
    | "shield"
    | "megaphone"
    | "gitCompare"
    | "history"
    | "layers"
    | "bot";

export type PlatformTile = {
    title: string;
    body: string;
    icon: PlatformIconName;
};

const PLATFORM_SIDES = {
    sideLeft: [
        { title: "Gestão de imóveis", body: "Cadastro e publicação", icon: "home" },
        { title: "Placas", body: "Controle operacional", icon: "flag" },
        { title: "Chaves", body: "Retirada e devolução", icon: "key" },
        { title: "Assinatura", body: "Eletrônica ilimitada", icon: "penTool" },
        { title: "Análise cadastral", body: "Regras configuráveis", icon: "waves" },
        { title: "Empreendimentos", body: "Gestão centralizada", icon: "building2" },
    ] satisfies PlatformTile[],
    sideRight: [
        { title: "Gestão de pessoas", body: "Histórico e contexto", icon: "user" },
        { title: "Etiquetas", body: "Compartilhadas e individuais", icon: "tag" },
        { title: "Dashboard", body: "Visão da gestão", icon: "layoutDashboard" },
        { title: "Relatórios", body: "Indicadores e acompanhamento", icon: "barChart" },
        { title: "Permissões", body: "Acesso por função", icon: "shield" },
        { title: "Site", body: "Presença digital integrada", icon: "globe" },
    ] satisfies PlatformTile[],
    bottom: [
        { title: "Memorando", body: "Comunicação interna", icon: "fileText" },
        { title: "Publicação", body: "Portais e site próprio", icon: "megaphone" },
        { title: "Matching", body: "Pessoas, interesses e imóveis", icon: "gitCompare" },
        { title: "Histórico", body: "Contexto da jornada", icon: "history" },
        { title: "SIMOB", body: "Integração nativa", icon: "layers" },
        { title: "LAIS IA", body: "Pré-atendimento inteligente", icon: "bot" },
    ] satisfies PlatformTile[],
} as const;

export const PLATFORM_TEXTO = {
    heading: "Uma plataforma que reúne os pilares essenciais para o comercial e para a operação imobiliária.",
    lead: "No centro, os pilares do que mais faz diferença no dia a dia. Ao redor, os recursos que sustentam a rotina e ajudam a torná-la contínua, organizada e rastreável.",
    top: [
        { title: "Entrada de leads", body: "Captação e origem", icon: "zap" },
        { title: "Roleta", body: "Distribuição de leads", icon: "target" },
        { title: "Kanban", body: "Funis e acompanhamento", icon: "layoutGrid" },
        { title: "Atividades", body: "Prazos e execução", icon: "clock" },
        { title: "Inteligência artificial", body: "Resumo e apoio de leitura", icon: "sparkles" },
        { title: "Integrações", body: "Portais e ecossistema", icon: "share2" },
    ] satisfies PlatformTile[],
    ...PLATFORM_SIDES,
    focus: [
        {
            title: "WhatsApp",
            body: "Atendimento dentro do CRM com dados do lead, histórico e mais contexto desde o primeiro contato.",
            icon: "messageCircle",
        },
        {
            title: "Gestão de tarefas",
            body: "Responsáveis, prazos, prioridades e acompanhamento para dar continuidade à rotina.",
            icon: "checkSquare",
        },
        {
            title: "Automações",
            body: "Criação e encaminhamento de tarefas entre funis, etapas e setores.",
            icon: "sparkles",
        },
        {
            title: "Aplicativo",
            body: "Interesses, atividades, imóveis e pessoas no celular, com notificações para manter a rotina em movimento.",
            icon: "smartphone",
        },
    ] satisfies PlatformTile[],
} as const;

export const PLATFORM_VIDEO = {
    heading: "Os principais recursos da operação imobiliária trabalhando juntos.",
    lead: "No centro, os pilares da rotina. Ao redor, os recursos que sustentam comercial, operação e gestão.",
    top: [
        { title: "Entrada de leads", body: "Captação e origem", icon: "zap" },
        { title: "Roleta", body: "Distribuição de leads", icon: "target" },
        { title: "Kanban", body: "Funis e acompanhamento", icon: "layoutGrid" },
        { title: "Atividades", body: "Prazos e execução", icon: "clock" },
        { title: "Inteligência artificial", body: "Resumo e contexto", icon: "sparkles" },
        { title: "Integrações", body: "Portais e ecossistema", icon: "share2" },
    ] satisfies PlatformTile[],
    ...PLATFORM_SIDES,
    focus: [
        {
            title: "WhatsApp",
            body: "Atendimento conectado ao lead, histórico e próximas ações desde o primeiro contato.",
            icon: "messageCircle",
        },
        {
            title: "Gestão de tarefas",
            body: "Responsáveis, prazos, prioridades e acompanhamento para dar continuidade à rotina.",
            icon: "checkSquare",
        },
        {
            title: "Automações",
            body: "Criação e encaminhamento de tarefas entre funis, etapas e setores.",
            icon: "sparkles",
        },
        {
            title: "Aplicativo",
            body: "Interesses, atividades, imóveis e pessoas no celular com notificações.",
            icon: "smartphone",
        },
    ] satisfies PlatformTile[],
} as const;
